import { apiGet, apiPost } from "./client";
import type { IntegrationCredentialStatus } from "@sales-ops-amplify/shared";

export async function connectSlack(
  webhookUrl: string,
): Promise<{ connected: boolean; message?: string }> {
  return apiPost("/api/crm/slack/connect", { webhookUrl });
}

export async function disconnectSlack(): Promise<{ connected: boolean }> {
  return apiPost("/api/crm/slack/disconnect");
}

export async function getSlackStatus(): Promise<IntegrationCredentialStatus> {
  return apiGet("/api/crm/slack/status");
}
